import React from 'react'
import Navbar from './navbar'
import imagemLogo from '../../assets/images/sologobranca.png';
import { withRouter } from "react-router-dom";

const Header = (props) => {

    return (
        <nav className="main-header navbar navbar-expand navbar-light navbar-white border-bottom-0"
            style={{
                backgroundColor: '#0042E2',
                color: '#ffffff',
                position: 'sticky',
                top: 0
            }}>
            <div
                style={{
                    width: '100%',
                    textAlign: 'center'
                }}>
                <img src={imagemLogo} style={{ height: 60, marginLeft: 40 }}/>
            </div>
            <Navbar selecionado={props.location.pathname} />
        </nav>
    );
}

export default withRouter(Header);

/*
<header className='main-header'>
    <a href='/#/' className='logo'>
        <span className='logo-mini'>
            <i className="fa fa-tachometer"></i>
        </span>
        <span className='logo-lg'>
            <b> Ottonelli Terraplanagem</b>
        </span>
    </a>
    <nav className='navbar navbar-static-top'>
        <a href className='sidebar-toggle' data-toggle='offcanvas'></a>
		<Navbar />
    </nav>
</header>
*/
